import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import SideBySideTimeTrackingIcon from '../components/SideBySideTimeTrackingIcon';
import showForTimeTrackingEnabled from '../hoc/showForTimeTrackingEnabled';
import { getBarberActive } from '../selectors';
import sideBySideShowForCurrentDay from '../hoc/sideBySideShowForCurrentDay';
import { isBarberUser } from '../../../auth/selectors';

const mapStateToProps = (state, ownProps) => ({
  active: getBarberActive(state, ownProps.barberId),
  isBarberUser: isBarberUser(state),
});

const SideBySideTimeTrackingIconContainer = compose(
  sideBySideShowForCurrentDay,
  showForTimeTrackingEnabled,
  connect(mapStateToProps),
  branch(
    props => props.isBarberUser,
    renderNothing
  ),
)(SideBySideTimeTrackingIcon);

export default SideBySideTimeTrackingIconContainer;
